import { getHomeData, getCaptcha, sendCode, userInfo, login } from '@/api/system.api.js'

import cookies from '@/utils/cookie'
import { getSign } from '@/utils/common.js'

const state = {
  stage: undefined, // 网站阶段（0：预约，1：下载）
  needVerifyCode: undefined, // 是否需要填写图形验证码
  tipsDialogVisible: false, // 提示窗口状态
  tips: '', // 提示内容
  loginDialogVisible: false, // 登录窗口状态
  bindDialogVisible: false, // 角色绑定窗口状态
  inviteCount: {2: 0, 3: 0}, // 邀请人数
  isReserved: 0, // 是否已预约（0：否，1：是）
  user: {}, // 用户信息
  selectedRole: {}, // 当前绑定角色
  downloadUrl: {}, // 下载地址
}

const getters = {
  stage: state => state.stage,
  needVerifyCode: state => state.needVerifyCode,
  tipsDialogVisible: state => state.tipsDialogVisible,
  tips: state => state.tips,
  loginDialogVisible: state => state.loginDialogVisible,
  bindDialogVisible: state => state.bindDialogVisible,
  inviteCount: state => state.inviteCount,
  isReserved: state => state.isReserved,
  user: state => state.user,
  selectedRole: state => state.selectedRole,
  downloadUrl: state => state.downloadUrl,
}

const actions = {
  // 获取首页数据
  async getHomeData({ state }) {
    const params = {

    }
    const homeData = await getHomeData(params)
      .then((res) => {
        const homeData = {
          videoSrc: '',
          newsPicList: [],
          characterList: [],
          featureList: [],
        }

        homeData.videoSrc = res.videoUrl

        if (res.picList.lunbo1) homeData.newsPicList = res.picList.lunbo1

        // 处理角色展示轮播图
        let characterList = []
        if (res.picList.characters) {
          characterList = JSON.parse(JSON.stringify(res.picList.characters))
          // 角色轮播特效需要至少4张图，如果图片不够四张则随机加入已有图片直到满4张
          while (characterList.length < 4) {
            const random = Math.floor(Math.random() * (res.picList.characters.length))
            characterList.push(res.picList.characters[random])
          }

          const list = []
          for (let i = 0; i < characterList.length; i++) {
            list.push({
              avatar_active: characterList[i].small,
              avatar_inactive: characterList[i].small2,
              img: characterList[i].big,
              description: characterList[i].desc,
            })
          }

          homeData.characterList = list
        }

        // 处理游戏特色轮播图
        let featureList = []
        if (res.picList.lunbo2) {
          featureList = JSON.parse(JSON.stringify(res.picList.lunbo2))
          // 游戏特色轮播特效需要至少4张图，如果图片不够四张则随机加入已有图片直到满4张
          while (featureList.length < 4) {
            const random = Math.floor(Math.random() * (res.picList.lunbo2.length))
            featureList.push(res.picList.lunbo2[random])
          }
          homeData.featureList = featureList
        }

        return homeData
      })

      return homeData
  },
  // 获取验证码
  async getCaptcha() {
    const captcha = await getCaptcha()
      .then((res) => {
        if (res.code == 0) {
          return res.data
        }

        return {}
      })

    return captcha
  },
  // 获取手机验证码
  async getPhoneCode({ commit }, { token, phone }) {
    const params = {
      token: token,
      phone: phone,
      codeType: 1
    }
    await sendCode(params)
      .then((res) => {
        if (res.code != 0) {
          commit('setTipsDialog', { visible: true, tips: res.msg })
          return false
        }
      })
  },
  // async getUserInfo({ commit }) {
  //   const params = {
      
  //   }
  //   await userInfo(params)
  //   .then((res) => {
  //     if (res.code != 0) {
  //       commit('setTipsDialog', { visible: true, tips: res.message })
  //       return false
  //     }

  //     commit('setUser', res.data)
  //   })
  // },
  // 登录
  async doLogin({ state, commit }, { form, osID }) {
    const postData = {
      phone: form.phone,
      verifyCode: form.code,
      time: Date.parse(new Date()) / 1000,
    }
    if (this.needVerifyCode) {
      postData.code = form.captcha
      postData.verifyCodeHash = form.captcha_id
    }
    postData.channel = form.os == 0 ? osID.android : osID.ios
    postData.sign = getSign(postData)
    const res = await login(postData)
      .then((res) => {
        if (res.code != 0) {
          commit('setTipsDialog', { visible: true, tips: res.msg })

          return {}
        } else {
          commit('setIsReserved', res.data.status)
          
          return res.data
        }
      })

    return res
  },
  handleLoginSuccess({ state, commit }, { data }) {
    commit('setLoginDialog', { visible: false })

    const userInfo = {
      username: data.userAccount,
      token: data.token,
    }
    commit('setUser', userInfo)

    // 缓存用户信息
    let date = new Date()
    let expires = data.expires ? data.expires : 86400
    date.setTime(date.getTime() + expires * 1000)

    cookies.set('cqytj', 'userInfo', JSON.stringify(userInfo), { expires: date })
  }
}

const mutations = {
  async setStage(state, value) {
    state.stage = value
  },
  async setNeedVerifyCode(state, value) {
    state.needVerifyCode = value
  },
  async setTipsDialog(state, { visible, tips }) {
    state.tipsDialogVisible = visible
    state.tips = tips
  },
  async setLoginDialog(state, { visible }) {
    state.loginDialogVisible = visible
  },
  async setBindDialog(state, { visible }) {
    state.bindDialogVisible = visible
  },
  async setInviteCount(state, { invite, download }) {
    if (invite) state.inviteCount[2] = invite
    if (download) state.inviteCount[3] = download
  },
  async setIsReserved(state, value) {
    state.isReserved = value
  },
  async setUser(state, value) {
    state.user = value
  },
  async setSelectedRole(state, value) {
    state.selectedRole = value
  },
  setDownloadUrl(state, value) {
    state.downloadUrl = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}